import { Link } from '@talend/design-system';

export default Link;
